export { default } from "./LabelTag.vue";

export const OutOfStock = "oos";

export type LabelTagColor = "blue" | "green" | typeof OutOfStock;
